import { HW_API_URL } from "../../configs";
import { fetcher } from "../../libs";

import { StatesParams, StatesResponse } from "./types";

/**
 * The country/state list is being migrated from php-api to hunkware-api
 * (`docs/migrations/public-website-states/`).
 *
 * Transport-only: the Node route runs the very same engine as php's wrapper and returns the same
 * snake_case wire (`country`, `country_full`, `state`, `state_full`) inside the same `meta`
 * envelope, so the fetcher's deep camelCase transform still yields the `State` shape `AddressFields`
 * reads. An absolute URL bypasses the fetcher's `baseURL` (php-api's `/public/website`) while
 * keeping both interceptors — including the error interceptor, which reads `meta.status`,
 * `meta.series` and `meta.errors[].http_code` off the legacy envelope a parity port reproduces.
 *
 * This is the id-less URL form. customer-portal calls the `/{account_id}/states` form of the same
 * php registration; the captured id is read by nothing, so both answer identically.
 *
 * No credential is sent either way: php registers the route with `allow_anonymous_login => true`
 * and this app sends no `Authorization` header, so the request is served as the anonymous user on
 * both hosts.
 *
 * Direct concatenation is safe here: booking-v4 sets `VITE_HW_API_URL` to the bare `/api` mount in
 * every environment. booking-v1/v2 scope theirs to `/api/v1/booking` and must use `buildHwApiUrl`.
 *
 * @param useNode value of the `HunkWare_Geolocation_Address_Services_Node_Migration` flag. Roll back
 *   by turning the flag off — no deploy needed. **The flag is the address/geolocation FAMILY switch,
 *   shared with customer-portal's states caller and with every future `/public/website/*` address
 *   route**, so a rollback reverts those too (doc 07).
 */
const NODE_STATES_URL = `${HW_API_URL}/v1/public/website/states`;

export const getStates = ({ useNode = false }: StatesParams) =>
  fetcher.get<StatesResponse>(useNode ? NODE_STATES_URL : "/states");
